@if (isPastQueriesRoute) {
  <app-paid-past-queries-sheet [routeMode]="true" [queries]="recentSupportTickets$ | async" />
}

@if (showNewHelpTicketList) {
  <div class="hbox tw-bg-gray-100 tw-font-lexend">
    <div class="flex-box pos-rel">
      @if (inProcess$ | async) {
        <loading class="pos-abs vh-center"></loading>
      }
      <div class="flex-heading">
        <div class="tw-h-16 tw-px-6 tw-pt-6 tw-flex tw-items-start tw-w-full tw-z-[100]">
          <button type="button" aria-label="Back" class="tw-m-0 tw-flex tw-h-10 tw-min-w-0 tw-w-10 tw-items-center tw-justify-center tw-rounded-xl tw-bg-gray-800 tw-p-0 tw-shadow-z13" (click)="back()">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
          </button>
        </div>
      </div>
      @if (!(inProcess$ | async)) {
        <div class="flex-content tw-bg-gray-100 tw-px-6 tw-pb-6">
          @if ((activeQueries$ | async)?.length) {
            <div i18n="@@activeQueries" class="tw-text-gray-800 tw-font-medium tw-text-300 tw-mb-4">Active Queries</div>
          }
          @for (ticket of (activeQueries$ | async); track ticket) {
            <div class="recent-queries-new tw-relative" (click)="viewQuery(ticket)">
              @if (ticket.hasUnreadMessage || (pendingResponseMap && pendingResponseMap[ticket.objectId])) {
                <div class="tw-relative tw-top-[-8px] tw-right-[-4px] tw-z-10"
                  >
                  <img src="/assets/gifs/blinking-red-dot.gif" alt="red-blink-circle" class="tw-w-[10px] tw-aspect-square tw-absolute tw-top-[-4px] tw-right-[-4px]"/>
                </div>
              }
              <div class="tw-flex tw-font-body tw-justify-between tw-text-100 tw-text-gray-400 tw-items-center tw-mb-[10px]">
                <span class="tw-capitalize">
                  {{ ticket?.llmResponse && ticket?.llmResponse?.category !== 'default' ? ticket?.llmResponse?.category : 'Query' }}
                </span>
                <span>
                  {{ ticket.createdAt | date: 'dd MMM yyyy, hh:mm a' }}
                </span>
              </div>
              <div class="tw-pb-8 tw-mt-3 tw-font-body tw-text-300"> {{ticket.title || ticket?.supportQuestion?.questionLanguageString[ticket.languagePreference]}}</div>
              <div class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0">
                @if (!(pendingResponseMap && pendingResponseMap[ticket.objectId])) {
                  <div class="tw-border-t tw-ml-3 tw-mr-3 tw-border-gray-200"></div>
                }
                <div class="tw-px-4 tw-py-2 tw-flex tw-items-center tw-justify-between tw-text-base tw-text-200" [ngClass]="{ 'tw-bg-teal-100': pendingResponseMap && pendingResponseMap[ticket.objectId] }">
                  @if (pendingResponseMap && pendingResponseMap[ticket.objectId]) {
                    <span i18n="@@awaitingResponse" class="tw-text-teal-600">AWAITING YOUR RESPONSE</span>
                  }
                  @if ((!(pendingResponseMap && pendingResponseMap[ticket.objectId]) && ticket.teams[0] !== 'bot' && ticket.status === appConfig.Shared.Ticket.status.Pending) || ticket.status === appConfig.Shared.Ticket.status.RequestClosure) {
                    <span i18n="@@inProcessTicket" class="tw-text-teal-600">IN-PROCESS</span>
                  }
                  @if (ticket.teams[0] === 'bot' && ticket.status === appConfig.Shared.Ticket.status.Pending && !(pendingResponseMap && pendingResponseMap[ticket.objectId])) {
                    <span i18n="@@openTicket" class="tw-text-red-400">OPEN</span>
                  }
                  <img src="/assets/icons/chevron_right_teal.svg" alt="chevron right"/>
                </div>
              </div>
            </div>
          }
          @if ((pastQueries$ | async)?.length) {
            <div [class.tw-mt-8]="(activeQueries$ | async)?.length" [class.tw-mt-1]="!(activeQueries$ | async)?.length" i18n="@@pastQueries" class="tw-text-gray-800 tw-font-medium tw-text-300 tw-mb-4">Past Queries</div>
          }
          @for (ticket of (pastQueries$ | async); track ticket) {
            <div class="recent-queries-new" (click)="viewQuery(ticket)">
              <div class="tw-flex tw-justify-between tw-text-100 tw-text-gray-400 tw-items-center tw-mb-3">
                <span class="tw-capitalize">
                  {{ ticket?.llmResponse && ticket?.llmResponse?.category !== 'default' ? ticket?.llmResponse?.category : 'Query' }}
                </span>
                <span>
                  {{ ticket.createdAt | date: 'dd MMM yyyy, hh:mm a' }}
                </span>
              </div>
              <div class="tw-border-b tw-border-gray-300 tw-pb-3 tw-mt-3 tw-text-300">
                {{ticket.title ||
                ticket?.supportQuestion?.questionLanguageString[ticket.languagePreference]}}
              </div>
              <div class="tw-flex tw-items-center tw-justify-between tw-text-base tw-text-200 tw-text-teal-600 tw-pt-2">
                <div class="tw-text-200 tw-text-teal-600" i18n="@@supportTicketResolvedOpen">
      RESOLVED
      </div>
                <img src="/assets/icons/chevron_right_teal.svg" alt="empty cart"/>
              </div>
            </div>
          }
        </div>
      }
      <div class="flex-footer"></div>
    </div>
  </div>
}

@if (showLegacyTicketList) {
  <div class="hbox">
    <div class="flex-box pos-rel">
      @if (inProcess$ | async) {
        <loading class="pos-abs vh-center"></loading>
      }
      <div class="flex-heading">
        <div class="tw-bg-black tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]">
          <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
            <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
          </div>
          <span class="tw-font-body tw-font-bold tw-text-300 tw-text-white" i18n="@@recentSupportQueries">Support Queries</span>
        </div>
      </div>
      @if (!(inProcess$ | async)) {
        <div class="flex-content">
          @for (ticket of (recentSupportTickets$ | async); track ticket) {
            <div class="recent-queries tw-pb-6" (click)="viewQuery(ticket)">
              <div [ngClass]="{ 'tw-relative tw-w-3 tw-h-3 tw-top-[-8px] tw-right-[-4px] tw-rounded-[50%] tw-bg-green-400 tw-z-10 tw-float-right': ticket?.hasUnreadMessage }"></div>
              <div class="tw-flex tw-justify-between">
                <div class="timestamp tw-font-body tw-text-100">
                  {{ ticket.createdAt | date: 'dd MMM yyyy, hh:mm a' }}
                </div>
                <p class="tw-font-body tw-text-200 tw-text-black">
                  {{ ticket.ticketNumber }}
                </p>
              </div>
              <div class="tw-border-b tw-border-gray-300 tw-pb-3 tw-mt-3 tw-font-body tw-text-300">
                {{ticket.title ||
                ticket?.supportQuestion?.questionLanguageString[ticket.languagePreference]}}
              </div>
              <div class="mT10">
                @if (ticket.status === appConfig.Shared.Ticket.status.Completed) {
                <div class="status tw-font-body tw-text-200 red" i18n="@@supportTicketResolvedClosed">
      RESOLVED
      </div>
                }
                @if (ticket.status === appConfig.Shared.Ticket.status.Pending || ticket.status === appConfig.Shared.Ticket.status.RequestClosure) {
                  <div class="status tw-font-body tw-text-200 tw-uppercase" i18n="@@open">Open</div>
                }
                <i class="cs-icon-arrow"></i>
              </div>
            </div>
          }
        </div>
      }
      <div class="flex-footer"></div>
    </div>
  </div>
}
